import axios from 'axios';

// import env from 'react-dotenv';
import { DEV, QA, QAEU, PROD, PRODEU, LOCAL } from '../config';
// import errorHandler from './response-handler-interceptor';
import { UserId } from '../constants';

if (window.env) {
  if (window.env.REACT_APP_ENV === '__rae__') {
    window.config = LOCAL;
  }
  if (window.env.REACT_APP_ENV === 'DEV') {
    window.config = DEV;
  }
  if (window.env.REACT_APP_ENV === 'QA') {
    window.config = QA;
  }
  if (window.env.REACT_APP_ENV === 'QAEU') {
    window.config = QAEU;
  }
  if (window.env.REACT_APP_ENV === 'PROD') {
    window.config = PROD;
  }
  if (window.env.REACT_APP_ENV === 'PRODEU') {
    window.config = PRODEU;
  }

  // Runtime override from env.js
  if (window.config) {
    if (window.env.OKTA_CLIENT_ID && window.env.OKTA_CLIENT_ID !== '__okta_client_id__') {
      window.config = { ...window.config, clientId: window.env.OKTA_CLIENT_ID };
    }
  }
}

class HttpService {
  setAccessToken(accessToken) {
    this.accessToken = accessToken;
  }

  get(url, params, queryParams) {
    return axios.get(window.config.API_URL + url, {
      headers: this.getHeaders(),
      params: params,
      ...queryParams,
    });
  }

  post(url, data, params, queryParams) {
    return axios.post(window.config.API_URL + url, data, {
      headers: this.getHeaders(),
      params: params,
      ...queryParams,
    });
  }

  update(url, data, params) {
    return axios.put(window.config.API_URL + url, data, {
      headers: this.getHeaders(),
      params: params,
    });
  }

  delete(url, data) {
    return axios.delete(window.config.API_URL + url, {
      data: data,
      headers: this.getHeaders(),
    });
  }

  aiChat(type, url, data) {
    const AI_BASE_URL = 'aidata/';

    if (type === 'post') {
      return axios.post(window.config.RAPID_URL + AI_BASE_URL + url, data, {
        headers: this.getHeaders(),
      });
    } else if (type === 'get') {
      return axios.get(window.config.RAPID_URL + AI_BASE_URL + url, {
        headers: this.getHeaders(),
      });
    } else if (type === 'stream') {
      return fetch(window.config.RAPID_URL + AI_BASE_URL + url, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(data),
      });
    } else if (type === 'getPDF') {
      return fetch(window.config.RAPID_URL + AI_BASE_URL + url, {
        method: 'GET',
        headers: this.getHeaders(),
      });
    }
  }

  getHeaders() {
    const token = localStorage.getItem('token');
    const currentRoute =
      localStorage.getItem('currentRoute')?.substring(1) || '';
    return {
      Authorization: `Bearer ${token ?? ''}`,
      'Content-Type': 'application/json',
      UserId: UserId,
      SourcePage: currentRoute,
    };
  }

  getRapid(url, params, queryParams) {
    return axios.get(window.config.RAPID_URL + url, {
      headers: this.getHeaders(),
      params: params,
      ...queryParams,
    });
  }

  postRapid(url, data, params, queryParams) {
    return axios.post(window.config.RAPID_URL + url, data, {
      headers: this.getHeaders(),
      params: params,
      ...queryParams,
    });
  }
  putRapid(url, data, params, queryParams) {
    return axios.put(window.config.RAPID_URL + url, data, {
      headers: this.getHeaders(),
      params: params,
      ...queryParams,
    });
  }
}

export default new HttpService();
